import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funValidateNoInput, GetLoginCredentialDb, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faFile, faGem, faPlus, faPrint, faRefresh, faSave, faSquareXmark, faTemperatureEmpty, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid } from "@mui/x-data-grid"
import { calculateTotal, funCheckNumber } from "../../Utility/utility"
import { Box, Drawer, Typography } from "@mui/material"
import { setRedirectLink } from "../../state/accountSlice"
import { addDays } from "date-fns"
import { resetDetailParams, setInvoiceDetail } from "../../state/invoiceEntrySlice"
import { setModSettingData } from "../../state/memoEntrySlice"


const CreateGeneralPurchaseInvoice = () => {
    const { compCode, compState, isMultipleCompany, yearId } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.invoiceEntry)
    const { user, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("General Purchase Invoice")
    const [selBillType, setSelBillType] = useState("P")
    const [selTradeOf, setSelTradeOf] = useState("G")
    const [selPktType, setSelPktType] = useState("")
    const [isStPerDisable, setIsStPerDisable] = useState(false)
    const [brokPer, setBrokPer] = useState(0)
    const [tdsPer, setTdsPer] = useState(0)
    const [tdsAcId, setTdsAcId] = useState(0)
    const [isWithBill, setIsWithBill] = useState(false)
    const [updateFlag, setUpdateFlag] = useState(0)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const dispatch = useDispatch();
    const gridContainerRef = useRef(null)
    const [submitBtnId, setSubmitBtnId] = useState("")
    const [selModName, setSelModName] = useState("")
    const [openDrawer, setOpenDrawer] = useState(false)
    const [JvTrnData, setJvTrnData] = useState({
        trnNo: 0,
        tdsJvTrnNo: 0,
        tcsJvTrnNo: 0,
        excJvTrnNo: 0,
        excSedJvTrnNo: 0,
        excAedJvTrnNo: 0,
        bTrnNo: 0
    })
    const ENUM_UNIT = [{
        key: "pcs", value: "PCS"
    },
    { key: "nos", value: 'NOS' },
    { key: "Mtr", value: "MTR" },
    { key: "ltr", value: "LTR" },
    {
        key: "crt", value: "CRT"

    }]
    const onSuccessMastData = (data) => {
        if (data && Object.keys(data).length > 0) {
            if (data.bookMaster.length > 0) {
                setFormData({ ...formData, [formField.bookId]: data.bookMaster[0].Party_Id })
                funGenVouNo(data.bookMaster[0].Party_Id, isNewEntry)
            }
        }

    }
    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.generalPurchaseEntry.entryMasterData,
        queryKey: "fetchGeneralPurchaseMasterData",
        onSuccessTasks: onSuccessMastData

    })

    const funGenVouNo = (bookid, isNewVouNo) => {
        if (isNewVouNo && bookid && bookid != "" && selBillType != "" && selTradeOf != "") {
            generateVouNo({
                data: {
                    comp_code: compCode.join(","),
                    vou_type: selBillType,
                    book_id: bookid,
                    trade_of: selTradeOf,
                }
            })
        }
    }

    const onSuccessVouno = (data) => {
        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: data[0]?.new_vou_no ?? '',
            }))
        }
    }
    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.invoiceEntry.generateVoucherNo,
        queryKey: "generate-vouno",
        onSuccessTasks: onSuccessVouno
    })

    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.generalPurchaseEntry.add_update,
        queryKey: "funAddUpdateInvoice",
        onSuccessTasks: (data) => {
            dispatch(resetDetailParams());
            if (submitBtnId == 'btnSaveNew') {
                setFormData(emptyFormField)
                setRows([])
                window.location.reload();
            }
            else
                navigate(funGetMasterLink());
        }
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.generalPurchaseEntry.fetchEntryDetail,
        queryKey: "fetchInvoiceDetail",
    });

    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })

    const { mutate: funchkBillNo } = usePost({
        url: apiRoute.generalPurchaseEntry.checkBillNo,
        queryKey: "funcheck  Duplicate Bill No",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                setFormData({ ...formData, [formField.billNo]: "" })
                toast.error("Bill No Exist Enter Another", {
                    "position": "top-center"
                })
            }
        }
    })
    let gridData = []
    const funGetDupBillNo = (party_id, bill_no) => {
        if (party_id != "" && bill_no != "") {
            funchkBillNo({
                data: {
                    compcode: compCode.join(","),
                    bill_no: bill_no,
                    party_id: party_id,
                    bill_type: selBillType
                }
            })
        }
    }

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard)
        filterMatserData({
            data: {
                compcode: compCode ? compCode[0] : 0,
                tradeof: selTradeOf,
                billtype: selBillType

            }
        })

        filterModSetting({
            data: {
                page_mod: ENUM_MOD_NAME.GeneralPurchase,
                master_mod: ENUM_MOD_NAME.GeneralSettings
            }
        })
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { comp_code, transaction_id, bill_type, trade_of } = detailParams

            funGetDetail({
                data: {
                    compcode: comp_code,
                    transactionid: transaction_id,
                    billtype: bill_type,
                    tradeof: trade_of
                }
            })
        }

    }, [])


    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS)
            setModSettingParams({
                Visibility: {
                    [RowsField.meter]: getModVisiblity(ENUM_MOD_PARAMETER.GeneralPurchase.Meter, modData) ?? false,
                    [RowsField.weight]: getModVisiblity(ENUM_MOD_PARAMETER.GeneralPurchase.Weight, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.GeneralPurchase.LotNo, modData) ?? false,
                    [RowsField.itemDetail]: getModVisiblity(ENUM_MOD_PARAMETER.GeneralPurchase.ItemDetail, modData) ?? false,
                    [formField.brokerId]: getModVisiblity(ENUM_MOD_PARAMETER.GeneralPurchase.Broker, modData) ?? false,
                    [formField.locationId]: getModVisiblity(ENUM_MOD_PARAMETER.GeneralPurchase.Location, modData) ?? false,

                },
                Mandatory: {
                    "roundNetAmt": getModMandatory(ENUM_MOD_PARAMETER.GeneralPurchase.RoundNetAmt, modData) ?? false,
                    "zeroPcs": getModMandatory(ENUM_MOD_PARAMETER.GeneralPurchase.ZeroPcs, modData) ?? false,
                },
            })

        }

    }, [modSetting])



    function fun_calBrok_Amt(totalAmount, totalDiscAmt, brokPer) {
        let res = ((parseFloat(totalAmount) - parseFloat(totalDiscAmt)) * parseFloat(brokPer)) / 100
        return res.toFixed(2)
    }
    const setColumnRequired = (column) => {

        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Mandatory[column] : false
        else
            return false
    }
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {
            gridData = detail?.itemDetail.map((item, i) => {

                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    itemDetail: item?.Item_Det ?? "",
                    pcs: item?.Nos ?? 0,
                    meter: item?.Meter ?? 0,
                    weight: item?.Weight ?? 0,
                    rate: item?.Rate ?? 0,
                    unit: item?.Item_Unit ?? '',
                    amount: item?.Amount ?? 0,
                    dRate: item?.S_Rate ?? 0,
                    dAmount: item?.AmountD ?? 0,
                    convRate: item?.C_Rate ?? 0,
                    detailId: item?.DetailId ?? 0,
                    lotNo: item?.L_Code ?? "",
                    discPer: item?.DiscPer ?? 0,
                    discAmt: item?.DiscAmt ?? 0,
                    discAmtD: item?.DiscAmtD ?? 0,
                    stPer: item?.StPer ?? 0,
                    stAmt: item?.StAmt ?? 0,
                    astPer: item?.AstPer ?? 0,
                    astAmt: item?.AstAmt ?? 0,
                    netAmt: item?.Amount
                        ? fun_calNet_Amt(item?.Amount, item?.DiscAmt, item?.StAmt, item?.AstAmt)
                        : 0,
                    netAmtD: item?.AmountD
                        ? fun_calNet_AmtD(item?.AmountD ?? 0, item?.DiscAmtD ?? 0)
                        : 0,
                }
            })


        }
    }

    const formField = {
        transId: "transId",
        vouNo: "vouNo",
        bookId: "bookId",
        partyId: "partyId",
        brokerId: "brokerId",
        deliveryId: "deliveryId",
        billNo: "billNo",
        challanNo: "challanNo",
        challanDate: "challanDate",
        tradeType: "tradeType",
        locationId: "locaionId",
        billDate: "billDate",
        remark: "remark",
        dueDays: "dueDays",
        dueDate: "dueDate",
        pcs: "pcs",
        weight: "weight",
        brokPer: "brokPer",
        refTrnId: "refTrnId"

    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.billDate || key == formField.dueDate || key == formField.challanDate)
            acc[key] = new Date()
        else if (key == formField.netAmount || key == formField.dueDays || key == formField.pcs || key == formField.weight || key == formField.refTrnId)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})

    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [rows, setRows] = useState([])

    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "netAmt",
            }),
        [rows]
    )
    const net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "netAmtD",
            }),
        [rows]
    )


    const total_Weight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )

    const total_Meter = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "meter",
            }),
        [rows]
    )
    const total_Rate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_Pcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    const total_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const total_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_RateD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dRate",
            }),
        [rows]
    )
    const total_disc = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmt",
            }),
        [rows]
    )
    const total_discD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmtD",
            }),
        [rows]
    )
    const total_GSTtax = useMemo(

        () =>
            calculateTotal({
                data: rows,
                columnName: "stAmt",
            }),
        [rows]
    )
    const total_SGSTtax = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "astAmt",
            }),
        [rows]
    )

    function fun_calNet_Amt(amount, discAmt, stAmt, astAmt) {
        let res =
            (parseFloat(amount) - parseFloat(discAmt)) + (parseFloat(stAmt) + parseFloat(astAmt))
        if (setColumnRequired("roundNetAmt"))
            return Math.round(res)
        else
            return res.toFixed(2)

        //        return Math.round(res)
    }
    function fun_calNet_AmtD(amountD, discAmtD) {
        let res =
            (parseFloat(amountD) - parseFloat(discAmtD))
        return res.toFixed(2)
    }
    function fun_calTds_Amt(grossAmt, tdsPer) {
        let res = (parseFloat(grossAmt) * parseFloat(tdsPer)) / 100
        return res.toFixed(2)
    }
    const total_BrokAmt = useMemo(() => fun_calBrok_Amt(total_Amount, total_disc, brokPer), [rows, brokPer])
    const total_BrokAmtD = useMemo(() => fun_calBrok_Amt(total_AmountD, total_discD, brokPer), [rows, brokPer])
    const total_TDSAmt = useMemo(() => fun_calTds_Amt(total_Amount, tdsPer), [rows, tdsPer])
    const RowsField = {
        detailId: "detailId",
        id: "id",
        itemCode: "itemCode",
        itemName: "itemName",
        itemDetail: "itemDetail",
        lotNo: "lotNo",
        rate: "rate",
        amount: "amount",
        dRate: "dRate",
        dAmount: "dAmount",
        convRate: "convRate",
        unit: "unit",
        pcs: "pcs",
        weight: "weight",
        meter: "meter",
        itemUnit: "itemUnit",
        reportNo: "reportNo",
        discPer: "discPer",
        discAmt: "discAmt",
        discAmtD: "discAmtD",
        stPer: "stPer",
        stAmt: "stAmt",
        astPer: "astPer",
        astAmt: "astAmt",
        netAmt: "netAmt",
        netAmtD: "netAmtD",


    }
    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.meter]: 0,
        [RowsField.itemUnit]: "",
        [RowsField.itemDetail]: "",
        [RowsField.lotNo]: "",
        [RowsField.rate]: 0,
        [RowsField.amount]: 0,
        [RowsField.pcs]: 0,
        [RowsField.weight]: 0,
        [RowsField.discPer]: 0,
        [RowsField.discAmt]: 0,
        [RowsField.stPer]: 0,
        [RowsField.stAmt]: 0,
        [RowsField.astPer]: 0,
        [RowsField.astAmt]: 0,
        [RowsField.netAmt]: 0,
        [RowsField.dRate]: 0,
        [RowsField.dAmount]: 0,
        [RowsField.convRate]: 0,
        [RowsField.discAmtD]: 0,
        [RowsField.netAmtD]: 0,


    }

    const itemGridHeadClass = "bill-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })


    const inputBoxes = {
        Row1: [
            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Vou No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.bookId,
                name: formField.bookId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.bookMaster ? masterData?.bookMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },

        ],

        Row2: [

            {
                id: formField.partyId,
                name: formField.partyId,
                placeholder: "Trade Party Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.deliveryId,
                name: formField.deliveryId,
                placeholder: "Challan Party",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

        ],
        Row3: [
            {
                id: formField.challanNo,
                name: formField.challanNo,
                placeholder: "Challan No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.challanDate,
                name: formField.challanDate,
                placeholder: " Challan Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row4: [
            {
                id: formField.billNo,
                name: formField.billNo,
                placeholder: "Bill No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.billDate,
                name: formField.billDate,
                placeholder: " Bill Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row5: [
            {
                id: formField.brokerId,
                name: formField.brokerId,
                placeholder: "Broker",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.brokerMaster ? masterData?.brokerMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },

        ],
        Row6: [
            {
                id: formField.tradeType,
                name: formField.tradeType,
                placeholder: "Trade Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: ENUM_TRADE_TYPE,
                itemkey: "t_type",
                itemvalue: "t_type",
                isrequired: true,
            },


            {
                id: formField.remark,
                name: formField.remark,
                placeholder: "Remark.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ]

    }
    const funUpdateItemGst = (val, withBill) => {

        let newRows = [...rows]
        let autoGst = true
        rows.map((element, index) => {
            if (!withBill) {
                newRows[index].stPer = 0
                newRows[index].astPer = 0
                autoGst = false
            }
            funCalculateGst(newRows, element.itemCode, index, val, autoGst, false, withBill)
        })

    }

    const funCalculateGst = (newRows, itemCode, index, tradeType, isAutoGst, isReturnData, withBill) => {
        //if (masterData && Object.keys(masterData).length > 0) {

        if (itemCode != null && itemCode.length > 0 && itemCode != "") {
            const tempData = masterData.itemMaster.filter((ele) => ele.Item_Code.toLowerCase() == itemCode.toLowerCase())

            if (tempData) {

                if (tempData.length > 0) {
                    let t_StPer = parseFloat(tempData[0]?.STPer);
                    let t_AstPer = parseFloat(tempData[0]?.ASTPer)
                    //const calData=funCalAllAmount(newRows)
                    if (isAutoGst) {
                        if (tradeType == "OGS") {
                            newRows[index].stPer = t_StPer + t_AstPer
                            newRows[index].astPer = 0;
                            t_StPer = t_StPer + t_AstPer
                            t_AstPer = 0;
                        }
                        else {
                            newRows[index].astPer = t_AstPer;
                            newRows[index].stPer = t_StPer;
                        }
                    }
                    else {
                        t_StPer = newRows[index].stPer ?? 0
                        t_AstPer = newRows[index].astPer ?? 0
                    }
                    let tempTot = 0;


                    tempTot =
                        ((newRows[index].amount - newRows[index].discAmt ?? 0) *
                            t_StPer) /
                        100
                    newRows[index].stAmt = tempTot.toFixed(2)

                    tempTot =
                        ((newRows[index].amount - newRows[index].discAmt ?? 0) *
                            t_AstPer) /
                        100
                    newRows[index].astAmt = tempTot.toFixed(2)

                    tempTot = fun_calNet_Amt(
                        newRows[index].amount,
                        newRows[index].discAmt,
                        newRows[index].stAmt,
                        newRows[index].astAmt
                    )
                    newRows[index].netAmt = tempTot
                }
            }


            //}
        }
        if (isReturnData)
            return newRows
        else
            setRows(newRows)

        return newRows
    }
    const funSetTradeType = (partyId) => {
        if (partyId != "" && partyId != null) {
            let t_tradeType = formData.tradeType
            if (compState && compState?.trim() != "") {
                const tempData = masterData.acMaster.filter((ele) => ele.Party_Id == partyId)

                if (tempData && tempData?.length > 0) {
                    if (tempData[0]?.ADD_6.trim() != "") {
                        if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
                            t_tradeType = "RD"
                        else
                            t_tradeType = "OGS"
                    }
                    else
                        t_tradeType = "URD"
                }
                if (t_tradeType == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
                else setIsStPerDisable(true)
            }
            return t_tradeType
        }
        else
            return ""
    }


    const hanldeBlur = (e) => {

        const { value, name, id } = e.target
        let t_billNo = formData[formField.billNo]
        if (name == formField.challanNo && (t_billNo == '' || t_billNo == null)) {
            setFormData({
                ...formData, [formField.billNo]: value
            })
        }
        if (name == formField.billNo) {
            funGetDupBillNo(formData[formField.partyId], value)
        }

    }

    const handleChange = (e) => {
        const { name, value } = e.target
        let t_dueDate = formData[formField.dueDate]


        if (name == formField.dueDays) {
            if (formData[formField.billDate] && formData[formField.billDate] != ""
                && formData[formField.billDate] != "Invalid Date" && value != "") {
                t_dueDate = addDays(formData[formField.billDate], Number(value))
            }
        }
        setFormData({
            ...formData, [name]: value, [formField.dueDate]: t_dueDate
            // ,[formField.billNo]:t_billNo
        })
    }


    const handleAutoCompleteChange = (value, rowid, name) => {

        if (name == formField.partyId || name == formField.deliveryId || name == formField.tradeType || name == formField.bookId || name == formField.brokerId || name == formField.locationId) {
            let t_tradeType = formData.tradeType
            let t_deliveryId = formData[formField.deliveryId]
            if (name == formField.bookId) {
                // funGetDupBillNo(value, formData[formField.billNo])
                funGenVouNo(value, isNewEntry)

            }
            else if (name == formField.deliveryId)
                t_deliveryId = value;
            else if (name == formField.partyId) {
                t_tradeType = funSetTradeType(value)
                funGetDupBillNo(value, formData[formField.billNo])
                if (t_deliveryId == '' || t_deliveryId == null)
                    t_deliveryId = value

            }
            else if (name == formField.tradeType) {
                if (t_tradeType == "")
                    t_tradeType = value
                funUpdateItemGst(value.isWithBill)
            }
            setFormData({
                ...formData,
                [name]: value,
                [formField.tradeType]: t_tradeType,
                [formField.deliveryId]: t_deliveryId

            })
        }
        else {

            if (name == RowsField.itemName) {
                const index = rows.findIndex((ele) => ele.id == rowid)
                const tempdata = masterData.itemMaster
                const itemData = tempdata.filter((ele) => ele.Item_Code == value)
                let newRow = [...rows]
                funCalculateGst(newRow, value, index, formData.tradeType, true, false, isWithBill)
                if (itemData && itemData.length > 0) {
                    newRow[index].itemCode = itemData[0].Item_Code
                    newRow[index].itemName = itemData[0].Item_Desc
                    newRow[index].unit = itemData[0]?.Item_Unit
                    setRows(newRow)
                }
            }
            else {
                const index = rows.findIndex((ele) => ele.id == rowid)
                const newRow = [...rows]
                newRow[index].unit = value
                setRows(newRow)

            }
        }

    }
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        const rearrangedRows = updatedRows.map((row, index) => {
            if (row.id == 100)
                return row
            else
                return {
                    ...row,
                    id: index + 1, // Reassign IDs to start from 1 again
                }
        })

        setRows(rearrangedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }
    const funCalAllAmount = (rowData, index, pcs, weight, meter, currentID) => {

        let newRows = [...rows]
        if (rowData && rowData.length > 0)
            newRows = [...rowData]
        let t_Amount = 0
        let t_DAmount = 0
        let tempVal = 0

        let t_rate = newRows[index].rate && newRows[index].rate != null ? newRows[index].rate : 0
        const t_unit = newRows[index].unit ? newRows[index].unit.toLowerCase() : ""
        const t_pcs = pcs && pcs != null && pcs > 0 ? pcs : newRows[index].pcs ?? 0
        const t_weight = weight && weight != null && weight != "" && weight > 0 ? weight : newRows[index].weight ?? 0
        const t_meter = meter && meter != null && meter != "" && meter > 0 ? meter : newRows[index].meter ?? 0
        let t_DRate = newRows[index].dRate && newRows[index].dRate != null ? newRows[index].dRate : 0

        let conv_rate = newRows[index].convRate && newRows[index].convRate != null ? newRows[index].convRate : 0
        //&& CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar
        if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
            if ((currentID == RowsField.dRate || currentID == RowsField.convRate)) {
                tempVal = parseFloat(t_DRate) * parseFloat(conv_rate)
                t_rate = funCheckNumber(tempVal).toFixed(2)
            }
            else if (currentID == RowsField.rate || currentID == RowsField.convRate) {
                tempVal = parseFloat(t_rate) / parseFloat(conv_rate)
                t_DRate = funCheckNumber(tempVal).toFixed(2)
            }
        }

        if (t_unit != "") {
            if (t_unit == "mtr" || t_unit == "ltr") {
                tempVal = parseFloat(t_rate) * parseFloat(t_meter)
                t_Amount = funCheckNumber(tempVal).toFixed(2)
                tempVal = parseFloat(t_DRate) * parseFloat(t_meter)
                t_DAmount = funCheckNumber(tempVal).toFixed(2)
            }
            else if (t_unit == "kgs" || t_unit == "grm" || t_unit == "crt") {
                //tempVal = parseFloat(t_rate) * parseFloat(t_weight)
                tempVal = parseFloat(t_rate) * parseFloat(t_weight)
                t_Amount = funCheckNumber(tempVal).toFixed(2)
                tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
                t_DAmount = funCheckNumber(tempVal).toFixed(2)
            }
            else {
                tempVal = parseFloat(t_rate) * Number(t_pcs)
                t_Amount = funCheckNumber(tempVal).toFixed(2)
                tempVal = parseFloat(t_DRate) * Number(t_pcs)
                t_DAmount = funCheckNumber(tempVal).toFixed(2)
            }
        }
        else {
            tempVal = parseFloat(t_rate) * Number(t_pcs)
            t_Amount = funCheckNumber(tempVal).toFixed(2)
            tempVal = parseFloat(t_DRate) * Number(t_pcs)
            t_DAmount = funCheckNumber(tempVal).toFixed(2)
        }

        //  tempVal = parseFloat(t_rate) * parseFloat(t_weight)
        //t_Amount = funCheckNumber(tempVal).toFixed(2)
        // tempVal = parseFloat(t_DRate) * parseFloat(t_weight)
        // t_DAmount = funCheckNumber(tempVal).toFixed(2)

        let t_discAmt = 0
        let t_stAmt = 0
        let t_astAmt = 0
        let t_netAmt = 0
        let t_netAmtD = 0
        let t_discAmtD = 0
        if (t_Amount > 0) {

            t_discAmt = ((t_Amount * newRows[index]?.discPer ?? 0) / 100).toFixed(2)
            t_discAmtD = ((t_DAmount * newRows[index]?.discPer ?? 0) / 100).toFixed(2)

            t_stAmt = ((t_Amount - newRows[index]?.discAmt ?? 0) *
                parseFloat(newRows[index]?.stPer)) / 100

            t_astAmt =
                ((t_Amount - newRows[index]?.discAmt ?? 0) *
                    parseFloat(newRows[index]?.astPer ?? 0)) /
                100
        }
        t_netAmt = fun_calNet_Amt(
            t_Amount,
            t_discAmt,
            t_stAmt,
            t_astAmt
        )
        t_netAmtD = fun_calNet_AmtD(
            t_DAmount,
            t_discAmtD,
        )
        return {
            amount: t_Amount, discAmt: t_discAmt, astAmt: t_astAmt, stAmt: t_stAmt, netAmt: t_netAmt
            , dAmount: t_DAmount, discAmtD: t_discAmtD, dRate: t_DRate, rate: t_rate, netAmtD: t_netAmtD
        }

    }
    //end delete row from dynamic grid
    const handleInputChange = (rowId, e, name) => {

        let { value, id } = e.target
        let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rows]
        setSelectedGridRowId(index)

        newRows[index][id] = value


        if (id == RowsField.rate ||
            id == RowsField.pcs ||
            id == RowsField.weight ||
            id == RowsField.meter ||
            id == RowsField.discPer ||
            id == RowsField.stPer ||
            id == RowsField.astPer ||
            id == RowsField.convRate ||
            id == RowsField.dRate
        ) {


            let isAutoGst = true
            if (id == RowsField.stPer || id == RowsField.astPer) {
                isAutoGst = false
            }
            const calData = funCalAllAmount(newRows, index, 0, 0, 0, id)

            newRows[index].amount = calData.amount
            newRows[index].dAmount = calData.dAmount
            newRows[index].discAmtD = calData.discAmtD
            newRows[index].discAmt = calData.discAmt
            newRows[index].stAmt = calData.stAmt
            newRows[index].astAmt = calData.astAmt
            newRows[index].netAmt = calData.netAmt
            newRows[index].netAmtD = calData.netAmtD
            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                if (id != RowsField.dRate)
                    newRows[index].dRate = calData.dRate //.toFixed(2)
                if (id != RowsField.rate)
                    newRows[index].rate = calData.rate //.toFixed(2)
            }
            funCalculateGst(newRows, newRows[index][RowsField.itemCode], index, formData.tradeType, isAutoGst, false, isWithBill)

        }

        setRows(newRows)
    }
    const funIsFooter = (id) => {
        if (id == 100)
            return true
        else
            return false
    }
    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (
            <Input
                isRequired={is_required}
                id={RowsField[input_id]}
                type={input_type}
                size="sm"
                // label=""
                labelPlacement="outside"
                readOnly={is_readonly}
                isDisabled={input_id == "astPer" ? isStPerDisable : input_id == RowsField.lotNo || input_id == RowsField.pktNo ? is_readonly : false}
                placeholder={holder_text}
                //allow space in text box
                //onBlur={(e) => hanldeBlur(row.id - 1, e)}
                onKeyDown={(event) => {
                    if (['Space', 'ArrowLeft', 'ArrowRight'].includes(event.code)) {
                        return; // Do nothing
                    } else {
                        event.stopPropagation(); // Prevent other keys from propagating
                    }
                }}
                defaultValue=""
                value={
                    input_id == "astPer" || input_id == "astAmt"
                        ? isStPerDisable
                            ? "0"
                            : row[input_id]
                        : row[input_id]
                }
                onChange={(e) => handleInputChange(row.id, e, "")}
                className="max-w-xs mt-1"
                classNames={{
                    "input": `${input_type == "number" ? "text-right" : ""}  text-sm `,

                }}
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}

            ></Input>
        )
    }


    const setColumnDisable = (row) => {
        return false
    }

    const setColumnVisiblity = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
        else
            return true
    }

    const funFormFieldSetting = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            if (column == formField.brokerId || column == formField.locationId) {
                return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
            }
            else
                return true
        }
        else
            return true
    }
    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rate, RowsField.amount, RowsField.netAmt]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.netAmtD, RowsField.convRate, RowsField.discAmtD]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return false
    }
    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-center"> Total</div> :
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>

                                <FontAwesomeIcon
                                    color="red"
                                    className={`cursor-pointer`}
                                    onClick={() => handleDeleteRow(row.id)}
                                    icon={faSquareXmark}
                                ></FontAwesomeIcon>

                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>

                {funIsFooter(row.id) ? "" : row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.itemCode)}
                            size="sm"
                            color={"danger"}
                            id={RowsField.itemName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23 text-xs"

                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingData}
                            isReadOnly={selPktType == "MIX" && updateFlag == 0 ? false : setColumnDisable(row)}
                            isVirtualized
                            defaultItems={
                                masterData && masterData.itemMaster ? masterData?.itemMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.itemName)
                            }
                            //onChange={handleFormSelectionChange}
                            selectedKey={row.itemCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Item_Code}
                                >
                                    {item.Item_Code + "(" + item.Item_Desc + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }

                </div>
            ),
        },

        {
            field: RowsField.lotNo,
            headerName: selPktType != 'SNG' && selTradeOf == 'R' ? "Rought No" : "Lot No",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (

                <div>{funIsFooter(row.id) ? "" :
                    (renderInputCell(row, RowsField.lotNo, "text",
                        false,
                        "",
                        setColumnRequired(RowsField.lotNo)
                        , "", ""))
                }</div>

            ),
        },
        {
            field: RowsField.itemDetail,
            headerName: "Item Detail",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.itemDetail, "text",
                    selPktType == "MIX" && updateFlag == 0 ? false : setColumnDisable(row),
                    "", setColumnRequired(RowsField.itemDetail), "", "")
                }</div>
            )
        },
        {
            field: RowsField.unit,
            headerName: "Unit",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? "" :
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.itemCode)}
                            size="sm"
                            color={"warning"}
                            id={RowsField.itemName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23 text-xs"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingData}
                            isVirtualized
                            defaultItems={
                                ENUM_UNIT
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.unit)
                            }
                            //onChange={handleFormSelectionChange}
                            selectedKey={row?.unit && row?.unit != "" ? row.unit.toLowerCase() : row.unit}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.key}
                                >
                                    {item.value}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }
                </div>)
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_Pcs}</div> :
                    renderInputCell(row, RowsField.pcs, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.meter,
            headerName: "Meter",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right" >{total_Meter}</div> :
                    renderInputCell(row, RowsField.meter, "number",
                        setColumnDisable(row),
                        "", false, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{funIsFooter(row.id) ? <div className="text-right">{total_Weight}</div>
                    : renderInputCell(row, RowsField.weight, "number",
                        setColumnDisable(row),
                        "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right">{total_RateD}</div> :
                renderInputCell(row, RowsField.dRate, "number",
                    false,
                    //setColumnDisable(row),
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Amount($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right">{total_AmountD}</div> :
                renderInputCell(row, RowsField.dAmount, "number",
                    true,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.convRate,
            headerName: "Conv. Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"></div> :
                renderInputCell(row, RowsField.convRate, "number",
                    setColumnDisable(row),
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>{funIsFooter(row.id) ?
                <div className="text-right"> {total_Rate}</div> :
                renderInputCell(row, RowsField.rate, "number",
                    false,
                    // setColumnDisable(row),
                    "", true, "", "")
            }</div>
            )
        },
        {
            field: RowsField.amount,
            headerName: " Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_Amount}</div> : row[RowsField.amount]
                    }
                </div>)
        },
        {
            field: RowsField.discPer,
            headerName: "Disc %",
            width: 85,
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (<div>
                {funIsFooter(row.id) ? "" :
                    renderInputCell(row, RowsField.discPer, "number", false, "", false, "", "")
                }
            </div>
            )
        },

        {
            field: RowsField.discAmtD,
            headerName: "Disc Amt($)",
            width: 100,
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_discD}</div> :
                        renderInputCell(row, RowsField.discAmtD, "number", true, "", false, "", "")

                    }
                </div>)
        },
        {
            field: RowsField.discAmt,
            headerName: "Disc Amt",
            width: 100,
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_disc}</div> :
                        renderInputCell(row, RowsField.discAmt, "number", true, "", false, "", "")

                    }
                </div>)
        },


        {
            field: RowsField.stPer,
            headerName: !isStPerDisable ? "CGST %" : "IGST %",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? "" :
                        renderInputCell(row, RowsField.stPer, "number", false, "", false, "", "")
                    }
                </div>
            )
        },
        {
            field: RowsField.stAmt,
            headerName: !isStPerDisable ? "CGST" : "IGST",
            headerClassName: itemGridHeadClass,
            width: 120,
            headerAlign: "center",
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_GSTtax}</div> :
                        renderInputCell(row, RowsField.stAmt, "number", true, "", false, "", "")
                    }
                </div>
            )
        },
        {
            field: RowsField.astPer,
            headerName: "SGST%",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? "" :
                        renderInputCell(row, RowsField.astPer, "number", false, "", false, "", "")}
                </div>
            )
        },
        {
            field: RowsField.astAmt,
            headerName: "SGST",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{total_SGSTtax}</div> :
                        renderInputCell(row, RowsField.astAmt, "number", true, "", false, "", "")
                    }
                </div>
            )
        },
        {
            field: RowsField.netAmt,
            headerName: "Net Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{net_Amount}</div> : row[RowsField.netAmt]
                    }
                </div>)
        },
        {
            field: RowsField.netAmtD,
            headerName: "Net Amount($)",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {funIsFooter(row.id) ? <div className="text-right">{net_AmountD}</div> : row[RowsField.netAmtD]
                    }
                </div>)
        },


    ]
    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Vou No required"
        }

        if (formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Trade Party Name required"
        }
        if (formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
            newErrors[formField.bookId] = "Book Name required"
        }
        if (formData[formField.deliveryId] == "" || formData[formField.deliveryId] == "0") {
            newErrors[formField.deliveryId] = "Challan Party required"
        }

        // if (formData.billNo.trim() == "") {
        //     newErrors[formField.billNo] = "Bill No required"
        // }
        if (formData[formField.billDate] == null || formData[formField.billDate] == "" || formData[formField.billDate] == "Invalid Date") {
            newErrors[formField.billDate] = "Bill Date required"
        }
        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            const d = rows.filter(ele => ele.id != 100)
            if (d.length > 0) {
                for (let i = 0; i < d.length; i++) {
                    if (!setColumnRequired("zeroPcs")) {
                        if (rows[i].pcs == "" || rows[i].pcs == "0") {
                            if (!msg.includes("Pcs"))
                                msg = msg + "  Pcs ,";
                            no = 1
                        }
                    }
                    if (rows[i].rate == "" || rows[i].rate == "0") {
                        if (!msg.includes("Rate"))
                            msg = msg + "  Rate ,";
                        no = 1
                    }
                    // if (rows[i].weight == "" || rows[i].weight == "0") {
                    //     if (!msg.includes("Weight"))
                    //         msg = msg + "  Weight ,";
                    //     no = 1
                    // }
                    if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                        if (rows[i].convRate == "" || rows[i].convRate == "0") {
                            if (!msg.includes("Conv. Rate"))
                                msg = msg + "  Conv. Rate ,";
                            no = 1
                        }
                    }
                }
            }
            else {
                msg = "Add Atleast One  Item"
                no = 1
            }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }
        if (no)
            return msg + " is required"
        else return ""
    }

    const handleSubmit = (e) => {

        e.preventDefault()
        const newRows = rows.filter(ele => ele.id != 100)
        const validate_form = validateForm()
        const grid_msg = ValidateGrid()
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (grid_msg == "" && validate_form) {
            // if (detail && detail?.itemData?.length > 0) {
            //     if (formData.billNo == null || formData.challanNo == "" && !isNewEntry && detail?.itemData[0]?.Bill_No == '') {
            //         generateVouNo({
            //             data: {
            //                 comp_code: compCode.join(","),
            //                 vou_type: selBillType,
            //                 book_id: formData.bookId,
            //                 trade_of: selTradeOf,
            //             }
            //         })
            //     }
            // }
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    item_list: newRows,
                    deleteditem_list: deletedItemRows,
                    trans_id: formData[formField.transId],
                    bill_type: selBillType,
                    trade_of: selTradeOf,
                    nos: Number(total_Pcs),
                    weight: total_Weight,
                    meter: total_Meter,
                    with_bill: isWithBill ? 1 : 0,
                    vou_no: formData[formField.vouNo],
                    book_id: formData[formField.bookId],
                    party_id: formData[formField.partyId],
                    delivery_id: formData[formField.deliveryId],
                    trade_type: formData[formField.tradeType],
                    location_id: formData?.[formField.locationId] ?? '',
                    pkt_type: selPktType == 'SNG' ? selPktType : '',
                    broker_id: formData?.[formField.brokerId] ?? '',
                    challan_no: formData[formField.challanNo],
                    challan_date: formData[formField.challanDate],
                    bill_no: formData[formField.billNo],
                    bill_date: formData[formField.billDate],
                    due_days: formData[formField.dueDays],
                    remark: formData[formField.remark],
                    ref_trn: null,
                    br_per: brokPer && brokPer != "" ? brokPer : 0,
                    br_amt: total_BrokAmt,
                    br_amtd: total_BrokAmtD,
                    tds_per: tdsPer && tdsPer != "" ? tdsPer : 0,
                    tds_acid: tdsAcId,
                    tds_amt: total_TDSAmt,
                    net_amount: net_Amount,
                    net_amountd: net_AmountD,
                    gross_amt: total_Amount,
                    total_gst: total_GSTtax,
                    total_sgst: total_SGSTtax,
                    disc_amt: total_disc,
                    disc_amtd: total_discD,
                    jv_trn_data: JvTrnData,
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
        else {
            addToast({
                title: "",
                description: grid_msg,
                color: "danger"
            })
            // toast.error(grid_msg, {
            //     "position": "top-center"
            // })
        }
    }


    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            const newData = [...gridData, { id: 100, ...initialRow }].sort((a, b) => a.id - b.id)

            setRows(newData)
            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                if (detail?.itemData[0]?.Trade_Type == "URD" || detail?.itemData[0]?.Trade_Type == "RD") setIsStPerDisable(false)
                else setIsStPerDisable(true)

                setJvTrnData({
                    trnNo: detail?.itemData[0]?.Trn_No ?? 0,
                    tdsJvTrnNo: detail?.itemData[0]?.TdsjvTrnno ?? 0,
                    tcsJvTrnNo: detail?.itemData[0]?.TcsjvTrnno ?? 0,
                    excAedJvTrnNo: detail?.itemData[0]?.ExcaedjvTrnno ?? 0,
                    excSedJvTrnNo: detail?.itemData[0]?.ExcsedjvTrnno ?? 0,
                    excJvTrnNo: detail?.itemData[0]?.ExcjvTrnno ?? 0,
                    bTrnNo: detail?.itemData[0]?.BTrnno ?? 0
                })

                setBrokPer(detail?.itemData[0]?.BrPer ?? 0)
                setIsWithBill(detail?.itemData[0]?.BillYN ?? 0)
                setTdsPer(detail?.itemData[0]?.TdsPer ?? 0)
                setTdsAcId(detail?.itemData[0]?.Tds_AccountId ?? 0)
                setUpdateFlag(detail?.itemData[0]?.Update_Flag ?? 0)
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.bookId]: detail?.itemData[0]?.Account_Id ?? "",
                    [formField.brokerId]: detail?.itemData[0]?.Br_Id ?? "",
                    [formField.deliveryId]: detail?.itemData[0]?.D_Id ?? "",
                    [formField.partyId]: detail?.itemData[0]?.Party_Id ?? "",
                    [formField.locationId]: detail?.itemData[0]?.Lac_Id ?? "",
                    [formField.billNo]: detail?.itemData[0]?.Bill_No ?? "",
                    [formField.billDate]: detail?.itemData[0]?.Bill_Date ?? "",
                    [formField.remark]: detail?.itemData[0]?.Remark ?? "",
                    [formField.tradeType]: detail?.itemData[0]?.Trade_Type ?? "",
                    [formField.pcs]: detail?.itemData[0]?.Pcs ?? "",
                    [formField.weight]: detail?.itemData[0]?.Weight ?? "",
                    [formField.refTrnId]: detail?.itemData[0]?.RefTrnId ?? null,
                    [formField.dueDays]: detail?.itemData[0]?.DueDays ?? 0,
                    [formField.dueDate]: detail.itemData[0]?.DueDays > 0 ? detail.itemData[0]?.Due_Date : detail.itemData[0]?.Bill_Date

                })
            }
        }

    }, [detail, masterData])

    const funGetMasterLink = () => {

        return linksUrl.invoiceEntry.genPurchaseEntryMaster
    }
    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const handleAddRow = () => {
        let new_initialRow = initialRow

        let newRowsId = rows.length + 1
        const newRow = { id: newRowsId, ...new_initialRow, }
        // setRows([...rows, newRow])

        if (rows.length == 0) {
            setRows([...rows, newRow
                , { id: 100, ...new_initialRow }
            ]
            )
        }
        else {
            newRowsId = rows.filter((ele) => ele.id != 100).length + 1
            const newData = [...rows, { id: newRowsId, ...new_initialRow, }]
            setRows(newData.sort((a, b) => a.id - b.id))
        }
        setTimeout(() => {
            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }
        }, 250)
        setTimeout(() => {
            const firstCell = gridContainerRef.current?.querySelector(
                `[data-id="${newRowsId}"] [data-field="id"]`
            );
            if (firstCell) {
                firstCell.focus();
            }
        }, 500);
    }
    const handleNewAcEntry = () => {
        filterMatserData({
            data: {
                compcode: compCode ? compCode[0] : 0,
                tradeof: selTradeOf,
                billtype: selBillType

            }
        })
        // let redLink = linksUrl.invoiceEntry.createGenPurchaseEntry

        // dispatch(setRedirectLink(redLink))
        // navigate(linksUrl.master.account.createAccountMaster)
    }
    const isDisableSubmit = () => {
        if (detailParams && Object.keys(detailParams).length > 0) {
            const { status } = detailParams
            if (status == ENUM_STATUS.Pending)
                return false
            else
                return true
        }
    }


    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }
    const disbaleInput = () => {
        //  if (isRefId)
        // return true
        // else
        return false
    }
    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel} Entry  `}
                breadcrumbs={['Purchase', entryLabel]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className="mb-3 w-full shadow p-3 bg-white">

                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        funFormFieldSetting(item.name) ?
                                                            <>
                                                                <Autocomplete
                                                                    size="md"
                                                                    name={item.name}
                                                                    isInvalid={errors[item.name]}
                                                                    errorMessage={errors[item.name]}
                                                                    label={item?.placeholder}
                                                                    eventResizeFeature={true}
                                                                    selectionMode="single"
                                                                    showScrollIndicators={true}
                                                                    labelPlacement={"outside"}
                                                                    placeholder={item.placeholder}
                                                                    isRequired={item.isrequired}
                                                                    isLoading={isLoadingData}
                                                                    menuTrigger={"input"}
                                                                    className="max-w-23"
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                    isClearable={false}
                                                                    isVirtualized
                                                                    isReadOnly={disbaleInput() ? true : false}
                                                                    defaultItems={
                                                                        item.data ? item.data : []
                                                                    }
                                                                    onSelectionChange={(e) =>
                                                                        handleAutoCompleteChange(e, '', item.name)
                                                                    }
                                                                    color={item.id == formField.partyId ? "success" : item.id == formField.deliveryId ? "warning" : item.id == formField.bookId ? "danger" : "default"}
                                                                    variant="flat"
                                                                    //onChange={handleFormSelectionChange}
                                                                    selectedKey={formData[item.name]}
                                                                >
                                                                    {(list) => (
                                                                        <AutocompleteItem

                                                                            key={list[item.itemkey]}
                                                                        >
                                                                            {list[item.itemvalue]}
                                                                        </AutocompleteItem>
                                                                    )}
                                                                </Autocomplete>
                                                                {item.name == formField.partyId ?
                                                                    <Chip className="cursor-pointer bg-orange-300 " color={"default"} onClick={handleNewAcEntry}>
                                                                        <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
                                                                    </Chip>
                                                                    : ""}
                                                            </> : ""
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    isReadOnly={disbaleInput() ? true : false}
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name])
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => {
                                                                        setFormData((prev) => {
                                                                            return {
                                                                                ...prev,
                                                                                [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                    dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                            };
                                                                        });
                                                                    }}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            onBlur={(e) => hanldeBlur(e)}
                                                            isReadOnly={(item.name == formField.vouNo || disbaleInput())
                                                                && (item.name != formField.billNo || item.name != formField.billDate) ? true : false}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }

                            <div>
                                <div className="flex justify-between items-center">

                                    <Button size="sm" color="success" radius="sm" className="text-white cursor-default  text-xs bg-emerald-600" startContent={<FontAwesomeIcon color="white" icon={faGem} />}
                                        onPress={handleAddRow}>
                                        ADD ITEM
                                    </Button>

                                    <h6 className="text-sm text-green-700" >Total Items :
                                        {rows && rows.length > 0 ? rows.length - 1 : 0}</h6>
                                </div>
                                {rows && rows?.length > 0 ? (
                                    <Box ref={gridContainerRef} sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            hideFooterPagination={true}
                                            hideFooter={true}
                                            columnHeaderHeight={30}
                                            rowHeight={45}
                                            disableColumnSorting={true}
                                            disableColumnMenu={true}
                                            getRowClassName={(params) => {
                                                if (params.id == 100) {
                                                    return 'sticky-row';  // Add custom class to the last row
                                                }
                                                return 'row-class';
                                            }}

                                            // getRowClassName={getRowClassName}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .row-class': {
                                                    fontSize: "12px",
                                                },
                                                '& .sticky-row': {
                                                    position: 'sticky',
                                                    bottom: 0,
                                                    color: "#dd115c",
                                                    backgroundColor: '#FFFFFF',
                                                    zIndex: 10,
                                                    height: 30, margin: 0,
                                                    fontWeight: "bold",
                                                    fontSize: "12px"

                                                },
                                                '& .sticky-row:hover': {
                                                    backgroundColor: "#ffffff"
                                                }
                                            }}
                                            columnVisibilityModel={{
                                                [RowsField.meter]: setColumnVisiblity(RowsField.meter),
                                                [RowsField.weight]: setColumnVisiblity(RowsField.weight),
                                                [RowsField.itemDetail]: setColumnVisiblity(RowsField.itemDetail),
                                                [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                [RowsField.discAmtD]: setCurrencyColumnVisiblity(RowsField.discAmtD),
                                                [RowsField.netAmt]: setCurrencyColumnVisiblity(RowsField.netAmt),
                                                [RowsField.netAmtD]: setCurrencyColumnVisiblity(RowsField.netAmtD),

                                            }}

                                        />

                                    </Box>
                                ) : (
                                    ""
                                )}
                            </div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Input
                                    size="md"
                                    type="number"
                                    label="Brok %"
                                    placeholder="Brok %"
                                    value={brokPer}
                                    labelPlacement={"outside"}
                                    className="max-w-25"
                                    variant="flat"
                                    color="danger"
                                    onChange={(e) => setBrokPer(e.target.value)}
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">%</span>
                                        </div>
                                    }
                                />
                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? "" :
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Brok. Amt"
                                        placeholder="Brok. Amt"
                                        value={total_BrokAmt}
                                        className="max-w-25"
                                        labelPlacement={"outside"}
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                }
                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Brok. Amt($)"
                                        placeholder="Brok. Amt"
                                        value={total_BrokAmtD}
                                        className="max-w-25"
                                        labelPlacement={"outside"}
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">$</span>
                                            </div>
                                        }
                                    />
                                }
                            </div>

                            <div>
                                <div className="flex  items-top gap-2 mt-7 ">
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Net Amount"
                                        placeholder="Net Amount"
                                        labelPlacement={"outside"}
                                        value={Number(net_Amount ?? 0)}
                                        className="max-w-25"
                                        variant="flat"
                                        color="success"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                    {/* <Input
                                        size="sm"
                                        type="number"
                                        label="Net Amount($)"
                                        placeholder="Net Amount($)"
                                        value={Number(net_AmountD ?? 0)}
                                        className="max-w-25"
                                        variant="flat"
                                        color="success"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">$</span>
                                            </div>
                                        }
                                    /> */}
                                    <Autocomplete
                                        size="md"
                                        name={"tdsAcId"}
                                        label={"Tds Ac"}
                                        eventResizeFeature={true}
                                        selectionMode="single"
                                        showScrollIndicators={true}
                                        labelPlacement={"outside"}
                                        placeholder={" "}
                                        isLoading={isLoadingData}
                                        menuTrigger={"input"}
                                        className="max-w-23"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        isClearable={false}
                                        isVirtualized
                                        color={"success"}
                                        defaultItems={
                                            masterData && masterData?.acMaster ? masterData?.acMaster : []
                                        }
                                        onSelectionChange={setTdsAcId}
                                        selectedKey={tdsAcId}
                                    >
                                        {(list) => (
                                            <AutocompleteItem

                                                key={list.Party_Id}
                                            >
                                                {list.Party_Name}
                                            </AutocompleteItem>
                                        )}
                                    </Autocomplete>
                                </div>
                            </div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Input
                                    size="md"
                                    type="number"
                                    label="TDS %"
                                    placeholder="TDS %"
                                    value={tdsPer}
                                    labelPlacement={"outside"}
                                    className="max-w-25"
                                    variant="flat"
                                    color="warning"
                                    onChange={(e) => setTdsPer(e.target.value)}
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">%</span>
                                        </div>
                                    }
                                />

                                <Input
                                    size="md"
                                    type="number"
                                    label="TDS. Amt"
                                    placeholder="TDS. Amt"
                                    value={total_TDSAmt}
                                    className="max-w-25"
                                    labelPlacement={"outside"}
                                    variant="flat"
                                    color="warning"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">₹</span>
                                        </div>
                                    }
                                />
                            </div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Input
                                    size="sm"
                                    type="text"
                                    name={formField.dueDays}
                                    label="Due Days"
                                    placeholder="Due Days"
                                    value={formData[formField.dueDays]}
                                    className="max-w-25"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    variant="flat"
                                    color="warning"
                                    onChange={(e) => funValidateNoInput(e.target.value) ? handleChange(e, formField.dueDays)
                                        : setFormData({ ...formData, [formField.dueDays]: 0 })}


                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={"Due Date"}
                                        views={["day", "month", "year"]}
                                        format="DD/MM/YYYY"
                                        value={
                                            formData[formField.dueDate]
                                                ? dayjs(formData[formField.dueDate])
                                                : formData[formField.dueDate]
                                        }
                                        onChange={(newValue) => {
                                            setFormData((prev) => {
                                                return {
                                                    ...prev,
                                                    [formField.dueDate]:
                                                        dayjs(newValue).format("YYYY-MM-DD"),

                                                };
                                            });
                                        }}
                                        //isRequired={item.required}
                                        className="w-full "
                                        slotProps={{
                                            textField: { size: "small", required: false },
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="p-7"></div>
                            <div className="fixed bottom-5 left-1/2 bg-white transform -translate-x-1/2 z-[9999] flex items-center gap-4 justify-center">
                                <Button
                                    id="btnsave"
                                    color="primary"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    isDisabled={isDisableSubmit()}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Save
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    isDisabled={isDisableSubmit()}
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>

                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </CardBody>
                    </form >
                </Card >
            </MainContainer>
        </div >
    )

}
export default CreateGeneralPurchaseInvoice
